<template lang="pug">
    .functional-tests-dictionary
        .edit-dictionary__top
            .edit-dictionary__name Функциональные тесты
            p Данный справочник служит для указания препаратов таргетной терапии. Доза, единицы измерения и кратность могут быть указаны только в соответствии с приведенными в справочнике значениями. Если поле оставлено пустым (например, не указано значение дозы), то пи заполнении карты пациента можно будет указать любое значение.
        dictionary-default-template(
            action-name="fetchFunctionalTests"
            getter-name="functionalTests"
            url-part="functional-tests"
        )
</template>

<script>
import DictionaryDefaultTemplate from '@/components/pages/dictionaries/DictionaryDefaultTemplate';

export default {
    name: 'functional-tests-dictionary',

    components: {
        DictionaryDefaultTemplate,
    },
};
</script>
